import { Button } from "@/components/design-system/button";
import FileUploadSection, {
  FileUploadSectionRef,
} from "@/modules/Assignments/components/FileUploadSection";
import { uploadFileService } from "@/service/base.service";
import { addQueryFeedbackService } from "@/service/feedback.service";
import { FeedbackFormData, QueryDetail } from "@/types/feedback.model";
import { useRef, useState } from "react";

function QueryFeedbackForm({
  query,
  onRefresh,
}: {
  query: QueryDetail;
  onRefresh?: () => void;
}) {
  const [noteText, setNoteText] = useState("");
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);

  const fileUploadRef = useRef<FileUploadSectionRef>(null);

  const handleFileUpload = (file: File | null) => {
    if (!file) {
      setUploadedFile(null);
      return;
    }

    setUploadedFile(file);
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      let payload: FeedbackFormData = {
        notes: noteText,
        query:
          query.threads.length > 0
            ? query.threads[query.threads.length - 1].id
            : "",
        uploads: [],
      };

      if (uploadedFile) {
        const {
          data: {
            data: { id },
          },
        } = await uploadFileService(uploadedFile as File);

        payload.uploads = [id];
      }

      await addQueryFeedbackService(payload);

      fileUploadRef.current?.clearSelectedFile();
      fileUploadRef.current?.clearSelectedRecordedFile();
      setNoteText("");
      setUploadedFile(null);

      if (onRefresh) onRefresh();
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setLoading(false);
    }
  };

  if (
    query.threads.length > 0 &&
    query.threads[query.threads.length - 1].type === "QUERY_FEEDBACK"
  ) {
    return <></>;
  }

  return (
    <div className="border rounded-b-xl border-[#EEEEEE]">
      <div className="h-[50px] px-[24px] py-[12px] border-b border-[#EEEEEE] flex items-center justify-between">
        <h3 className="text-xl font-semibold text-[#1F1F1F]">
          Add New Feedback
        </h3>
      </div>

      <div className="px-6 pt-6">
        <FileUploadSection
          ref={fileUploadRef}
          onFileUpload={handleFileUpload}
          showLabel={false}
          disabled={loading}
        />

        <div className="mb-4">
          <p className="text-base font-medium text-[#2D3748] mb-2">
            Write a note
          </p>
          <textarea
            className="w-full border border-gray-200 rounded-2xl p-3 min-h-[100px] text-base text-[#1F1F1F] focus:outline-none"
            placeholder="Enter a note"
            value={noteText}
            onChange={(e) => setNoteText(e.target.value)}
            disabled={loading}
          ></textarea>
        </div>
      </div>

      <div className="px-6 py-4.5 border-t border-[#EEEEEE]">
        <div className="flex items-center justify-between flex-wrap sm:flex-nowrap gap-2">
          <div className="flex items-center">
            <p className="text-xs text-[#1C1B1F] ">
              <span className="font-bold ">Note:</span> Upload MP4, MOV file (Up
              to 50 MB) / Upload MP3 file (Up to 10mb)/ PDF, DOCX
            </p>
          </div>

          <div className="flex items-center gap-2 sm:gap-4 flex-wrap sm:flex-nowrap">
            <Button
              variant={"primary"}
              className="h-[40px] w-[152px] rounded-[12px] bg-[#5C88C5]"
              disabled={!noteText}
              onClick={handleSubmit}
              loading={loading}
            >
              Add Feedback
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QueryFeedbackForm;
